import { Icon, PlusIcon } from './icons';

export interface FABProps {
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
}

export function FAB({ onClick, ariaLabel = 'Add customer', className = 'sm:hidden' }: FABProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className={`fixed bottom-6 end-6 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-green-800 text-white shadow-md transition-agrobook duration-agrobook hover:scale-105 hover:bg-green-700 ${className}`}
    >
      <Icon size="md">
        <PlusIcon />
      </Icon>
    </button>
  );
}
